import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { CHART_AXIS_TICK_FONT_SIZE_PX, CHART_HEIGHT_PX } from "../../config/appConstants";

const CHART_MARGIN = { left: 0, right: 8, top: 18, bottom: 0 };
const AXIS_TICK = { fill: "#888", fontSize: CHART_AXIS_TICK_FONT_SIZE_PX };
const Y_AXIS_DOMAIN = ["dataMin - 80", "dataMax + 80"];
const TOOLTIP_STYLE = { background: "#050505", border: "1px solid #222", color: "#fff" };

export function PriceChart({ bot, performance, selectedSymbol }) {
  return (
    <div className="panel chart-panel" data-testid="performance-chart-panel">
      <div className="panel-head">
        <div>
          <span className="label">PERFORMANCE</span>
          <h2 data-testid="selected-symbol-title">{selectedSymbol} Grid Range</h2>
        </div>
        <div className={bot.enabled ? "bot-chip on" : "bot-chip"} data-testid="bot-status-chip">
          {bot.enabled ? "BOT RUNNING" : "BOT PAUSED"}
        </div>
      </div>
      <ResponsiveContainer width="100%" height={CHART_HEIGHT_PX}>
        <AreaChart data={performance} margin={CHART_MARGIN}>
          <defs>
            <linearGradient id="pnl" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#00E676" stopOpacity={0.55} />
              <stop offset="95%" stopColor="#00E676" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="rgba(255,255,255,0.08)" vertical={false} />
          <XAxis dataKey="day" stroke="#666" tick={AXIS_TICK} />
          <YAxis stroke="#666" tick={AXIS_TICK} domain={Y_AXIS_DOMAIN} />
          <Tooltip contentStyle={TOOLTIP_STYLE} />
          <Area type="monotone" dataKey="value" stroke="#00E676" fill="url(#pnl)" strokeWidth={2} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}